import React, { Component } from 'react';
import _ from 'lodash';
import LocationsMap from '../LocationsMap';
import './Map_old.scss';

let LatLngBounds, LatLng;
if (window.google && window.google.maps) {
  LatLngBounds = window.google.maps.LatLngBounds;
  LatLng = window.google.maps.LatLng;
}

export default class MapOld extends Component {
  constructor(props) {
    super(props);

    this.state = {
      map: {},
      content: {},
    };

    this.setup = this.setup.bind(this);
    this.handleMapMounted = this.handleMapMounted.bind(this);
    this.handleMapZoom = this.handleMapZoom.bind(this);
  }

  componentDidMount() {
    this.setup(this.props);
  }

  // componentDidUpdate(prevProps) {
  //   this.setup(this.props)
  // }

  setup(props) {
    const { map } = this.state;

    if (!_.isEmpty(map)) {
      this.handleFitBounds(map, props);
    }
  }

  handleFitBounds(map, props) {
    if (!map) {
      map = this.state.map;
    }
    if (map && map.fitBounds) {
      const { contents } = props;
      let bounds = new LatLngBounds();

      contents.forEach(content => {
        if (content) {
          if (content.latitude && content.longitude) {
            bounds.extend(
              new LatLng(content.latitude, content.longitude)
            );
          }
        }
      });
      if (contents.length > 0 && map) {

        // if only one marker, extend bounds by 0.01 in each direction
        if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
          const extendPoint1 = new LatLng(bounds.getNorthEast().lat() + 0.01, bounds.getNorthEast().lng() + 0.01);
          const extendPoint2 = new LatLng(bounds.getNorthEast().lat() - 0.01, bounds.getNorthEast().lng() - 0.01);
          bounds.extend(extendPoint1);
          bounds.extend(extendPoint2);
        }

        map.fitBounds(bounds);
      }
    }
  }

  handleMapMounted(map) {
    this.setState({ map });
    const { ...props } = this.props;

    this.handleFitBounds(map, props);
  }

  handleMapZoom(){
    const { map, contents } = this.state;

    if (map && contents && contents.length == 1) {
      let zoom = map.getZoom();

      if (this.props.handleZoom) {
        this.props.handleZoom(zoom);
      }
    }
  }
  render() {

    const { contents, center, projects } = this.props;

    const containerElement = (
      <div style={{ height: '290px' }} />
    );

    const mapElement = (
      <div style={{ height: '100%' }} />
    );

    return (
      <div className="map-wrapper">
        <LocationsMap
          contents={contents}
          projects={projects}
          onShowContent={this.props.onShowContent}
          containerElement={containerElement} 
          mapElement={mapElement}
          center={center}
          zoom={this.props.zoom}
          onMapMounted={this.handleMapMounted}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Map_old/index.js